import {forwardRef} from 'react';
import {Button, Icon} from '@ezcater/tapas';
import {IconDefinition} from '@fortawesome/pro-regular-svg-icons';
import {twMerge} from 'tailwind-merge';

type AppBarIconButtonProps = Omit<React.ComponentProps<typeof Button>, 'variant'> & {
  icon: IconDefinition;
  count?: number;
  draftCountClassName?: string;
  variant?: 'default' | 'contrast' | 'secondary';
};

type Ref = HTMLButtonElement;

const AppBarIconButton = forwardRef<Ref, AppBarIconButtonProps>(
  ({icon, count, draftCountClassName, variant = 'secondary', ...props}, ref) => {
    return (
      <Button
        ref={ref}
        variant={variant === 'contrast' || variant === 'secondary' ? 'secondary' : 'primary'}
        {...props}
        className={twMerge(
          'relative h-12 p-1.5 no-underline',
          variant === 'contrast' &&
            'text-white hover:text-peppercorn-800 active:text-peppercorn-800',
          props?.className,
        )}
      >
        <Icon icon={icon} size="medium" />

        {!!count && (
          <span
            className={twMerge(
              'absolute right-2 top-2 flex h-5 min-w-5 -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-full bg-green-300 px-1 text-sm font-bold',
              draftCountClassName,
            )}
            data-testid="count-badge"
          >
            {count}
          </span>
        )}
      </Button>
    );
  },
);

export default AppBarIconButton;
